export const JOB_HEARTBEAT_INTERVAL_IN_MS = 60000; // 1 minute
